import { render } from "./OnboardingWelcomePage.vue?vue&type=template&id=3f8e2eae&ts=true"
import script from "./OnboardingWelcomePage.vue?vue&type=script&lang=ts"
export * from "./OnboardingWelcomePage.vue?vue&type=script&lang=ts"

import "./OnboardingWelcomePage.vue?vue&type=style&index=0&id=3f8e2eae&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__